import { Box, Button, Grid } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import KenGrid from '../../../../../global_components/KenGrid';
import KenInputField from '../../../../../global_components/KenInputField';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import KenSlider from '../../../../../global_components/KenSlider';
import { BsFillTrashFill } from 'react-icons/bs';
import { AiOutlinePlus } from 'react-icons/ai';
import { Line } from 'react-chartjs-2';
import { AiFillDelete } from 'react-icons/ai';
import { ToastContainer, toast } from 'react-toastify';
const dataChart = {
  // x- axis
  labels: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  datasets: [
    {
      label: 'Percentage',
      data: [0, 0, 0, 5, 35, 45, 77, 47, 18, 5, 0],
      fill: true,
      backgroundColor: 'rgba(9, 0, 119, 0.3)',
      borderColor: 'rgba(99, 87, 255, 1)',
    },
  ],
};
const legend = {
  display: true,
  position: 'left',
  labels: {
    fontColor: '#323130',
    fontSize: 14,
  },
};
const options = {
  plugins: {
    title: {
      display: true,
      text: 'Number of Student',
      position: 'left',
    },

    legend: {
      display: true,
      position: 'bottom',
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          suggestedMin: 0,
          suggestedMax: 100,
        },
      },
    ],
  },
};
// AiOutlinePlus
const selectOptionsCourse = [
  {
    label: 'ABSOLUTE',
    value: 'Absolute',
  },
  {
    label: 'RELATIVE',
    value: 'relative',
  },
];

const minDistance = 10;

export const GradeSetting = () => {
  const [cgpaInp, setFacultyInp] = useState({
    first: 10,
    second: 9,
    third: 8,
    forth: 7,
    fifth: 6,
  });

  const [value1, setValue1] = useState([80, 100]);
  const [value2, setValue2] = useState([60, 80]);
  const [value3, setValue3] = useState([40, 60]);
  const [value4, setValue4] = useState([20, 40]);
  const [value5, setValue5] = useState([0, 20]);
  const [dataArray, setDataArray] = useState([]);
  const [discard, setDiscard] = useState(false);
  const [discardRelated, setDiscardRelated] = useState(false);

  const [columnGridAbsolute, setColumnGradAbsolute] = useState([]);
  const [columnGridRelative, setColumnGradRelative] = useState([]);
  const [objSliderSetting, setObjSliderSetting] = useState([
    {
      value: [86, 100],
      cgpa: 10,
      grade: 'A+',
    },
    {
      value: [71, 85],
      cgpa: 9,
      grade: 'A',
    },
    {
      value: [56, 70],
      cgpa: 8,
      grade: 'B',
    },
    {
      value: [41, 56],
      cgpa: 7,
      grade: 'B+',
    },
  ]);
  const [gradeSubmit, setGradSubmit] = useState(true);
  const columnGradRelative = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'percentile',
      accessor: 'percentile1',
      disableGlobalFilter: true,
    },
    {
      Header: 'CGPA',
      accessor: 'cgpa1',
      disableGlobalFilter: true,
    },

    {
      Header: 'Grade name',
      accessor: 'grade_name1',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
  ];
  const handleChangeCgpa = (event, rows, index) => {
    setObjSliderSetting((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, cgpa: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const handleChange = (event, rows, index) => {
    setObjSliderSetting((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, grade: event.target.value };
        } else {
          return single;
        }
      });
    });
    // setGradeInp({
    //   [event.target.name]: event.target.value,
    // });
  };
  const cgpaCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            onChange={(e) => handleChangeCgpa(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const gradCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={4}>
          <KenInputField
            name={rows}
            value={rows}
            optionalLabel={false}
            onChange={(e) => handleChange(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const handleDelete = (rows) => {
    setDataGradAbsolute((pre) => pre.filter((item) => item.id !== rows));
  };
  const handleRelatedDelete = (rows) => {
    setDataGradAbsolute((pre) => pre.filter((item) => item.id !== rows));
    setObjSliderSetting((pre) => pre.filter((item, i) => i + 1 !== rows));
    toast.success('Row delete Sucessfully');
  };
  const deleteCell = (rows) => {
    return <AiFillDelete size={20} onClick={() => handleRelatedDelete(rows)} />;
  };
  const deleteRelatedCell = (rows) => {
    return <AiFillDelete size={20} onClick={() => handleRelatedDelete(rows)} />;
  };

  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleChange2 = (e, index, newValue) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    setObjSliderSetting((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, value: newValue };
        } else {
          return single;
        }
      });
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dataGrad = objSliderSetting.map((ele, i) => {
    console.log('elevalue', ele.value)
    return {
      id: i + 1,
      precentile_range:
        selectValueCourse === 'Absolute' ? (
          <KenSlider
            value2={ele.value}
            handleChange2={(e, value) => handleChange2(e, i, value, 0)}
            handleOnChangeCommitted={() => handleOnChangeCommitted()}
          />
        ) : (
          ''
        ),
      percentile: (
        <Grid item xs={12} sm={5}>
          <KenInputField
            optionalLabel={false}
            value={ele.value.join('-')}
            onChange={(e, value) => handleChangeSlider(e, i, value, 0)}
            onBlur={() => handleOnBlur()}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa: cgpaCell(ele.cgpa, i),
      grade_name: gradCell(ele.grade, i),
      delete: deleteCell(i + 1),
    };
  });
  const handleDiscard = () => {
    console.log('discard', discard);
    setDiscard(!discard);
    if (discard) {
      columnGrad.push({
        Header: 'Delete',
        accessor: 'delete',
        disableGlobalFilter: true,
        // Cell: QuestionPaperCell,
      });
    }
    setColumnGradAbsolute(columnGrad);
  };

  const handleRelatedDiscard = () => {
    setDiscardRelated(!discardRelated);
    if (discardRelated) {
      columnGradRelative.push({
        Header: 'Delete',
        accessor: 'delete1',
        disableGlobalFilter: true,
        // Cell: QuestionPaperCell,
      });
    }
    setColumnGradRelative(columnGradRelative);
  };
  useEffect(() => {
    setColumnGradRelative(columnGradRelative);
  }, []);
  const handleChangeSliderRelative = (e, index, newValue) => {
    let valueSlider = e.target.value.split(',');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (arrData[0] >= 0 && arrData[1] <= 100) {
    setObjSliderRelative((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, value: arrData };
        } else {
          return single;
        }
      });
    });
  }
  };
  const handleChangeRelative = (event, rows, index) => {
    setObjSliderRelative((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, grade: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const handleDeleteRelative = (rows) => {
    setDataGradRelated((pre) => pre.filter((item) => item.id !== rows));
    setObjSliderRelative((pre) => pre.filter((item, i) => i + 1 !== rows));
    toast.success('Row delete Sucessfully');
  };
  const handleChangeCgpaRelative = (event, rows, index) => {
    setObjSliderRelative((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, cgpa: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const deleteCellRelative = (rows) => {
    return (
      <AiFillDelete size={20} onClick={() => handleDeleteRelative(rows)} />
    );
  };
  const gradCellRelative = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={4}>
          <KenInputField
            name={rows}
            value={rows}
            optionalLabel={false}
            onChange={(e) => handleChangeRelative(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const cgpaCellRelative = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            onChange={(e) => handleChangeCgpaRelative(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const [objSliderRelative, setObjSliderRelative] = useState([
    {
      value: [86, 100],
      cgpa: 10,
      grade: 'A+',
    },
    {
      value: [71, 85],
      cgpa: 9,
      grade: 'A',
    },
    {
      value: [56, 70],
      cgpa: 8,
      grade: 'B',
    },
    {
      value: [41, 56],
      cgpa: 7,
      grade: 'B+',
    },
  ]);
  useEffect(() => {
    setDataGradRelated(dataGradRelative);
  }, [objSliderRelative]);
  const dataGradRelative = objSliderRelative.map((ele, i) => {
    return {
      id: i + 1,
      percentile1: (
        <Grid item xs={12} sm={6}>
          <KenInputField
            // label={'Average/Mean'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={ele.value}
            onChange={(e, value) => handleChangeSliderRelative(e, i, value, 0)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa1: cgpaCellRelative(ele.cgpa, i),
      grade_name1: gradCellRelative(ele.grade, i),
      delete1: deleteCellRelative(i + 1),
    };
  });
  console.log('dataGrad', dataGrad);
  const [dataGridAbsolute, setDataGradAbsolute] = useState(dataGrad);
  const [dataGridRelated, setDataGradRelated] = useState(dataGradRelative);

  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };
  useEffect(() => {
    // setObjSlider(pre => pre)
    setDataGradAbsolute(dataGrad);
  }, [objSliderSetting]);
  // const handleNewRow = () => {
  //   const ele = {
  //     id: dataGridRelated.length + 1,

  //     percentile1: (
  //       <Grid item xs={12} sm={6}>
  //         <KenInputField
  //           optionalLabel={false}
  //           value={value1}
  //           onChange={(e, value) => handleChangeSlider(e, value, setValue1)}
  //           style={{ fontSize: 12 }}
  //         />
  //       </Grid>
  //     ),
  //     cgpa1: cgpaCell(10),
  //     grade_name1: gradCell(1),

  //     delete1: deleteRelatedCell(dataGridRelated.length + 1),
  //   };
  //   dataArray.push(ele);
  //   console.log('eleele', ele);
  //   setDataGradRelated([...dataGridRelated, ele]);
  // };

  const handleAddRow = () => {
    let objNewSlider = {
      value: [0, 0],
      cgpa: '--',
      grade: '--',
    };
    setObjSliderSetting((preState) => [...preState, objNewSlider]);
    toast.success('Row Added Sucessfully');
  };
  console.log('dataGridAbsolute', dataGridAbsolute);

  const handleOnChangeCommitted = (check) => {
    let arr = [];
    objSliderSetting.forEach((ele) => {
      arr = [...arr, ...ele.value];
    });
    for (let i = 0; i < arr.length; i = i + 2) {
      if (arr[i] <= arr[i + 3]) {
        setGradSubmit(false);
        toast.error('Please Enter the Correct Range');
        return;
      } else {
        if (check && gradeSubmit) {
          toast.success('submit succesfully');
          // handleClickSlider();
          setGradSubmit(true);
        }
        setGradSubmit(true);
        return;
      }
    }
  };
  const handleChangeSlider = (e, index, newValue) => {
    console.log('value--->', e.target.value.split('-'))
    let valueSlider = e.target.value.split('-');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (arrData[0] >= 0 && arrData[1] <= 100) {
      setObjSliderSetting((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return { ...single, value: [arrData[0] || 0, arrData[1] || 0]  };
          } else {
            return single;
          }
        });
      });
    }
  };
  const handleNewRowRelative = () => {
    let objNewSlider = {
      value: [0, 0],
      cgpa: '--',
      grade: '--',
    };
    setObjSliderRelative((preState) => [...preState, objNewSlider]);
    toast.success('Row Added Sucessfully');
  };
  // const handleChangeSlider = (e, val, setVal, activeThumb = 0) => {
  //   console.log('cell', e.target.value.split(','));
  //   if (!Array.isArray(e.target.value.split(','))) {
  //     return;
  //   }

  //   if (
  //     e.target.value.split(',')[1] - e.target.value.split(',')[0] <
  //     minDistance
  //   ) {
  //     if (activeThumb === 0) {
  //       const clamped = Math.min(
  //         e.target.value.split(',')[0],
  //         100 - minDistance
  //       );
  //       console.log('clam1', clamped);
  //       setVal([clamped, e.target.value.split(',')[1]]);
  //     } else {
  //       const clamped = Math.max(e.target.value.split(',')[1], minDistance);
  //       console.log('clam2', clamped);
  //       setVal([clamped - minDistance, clamped]);
  //     }
  //   } else {
  //     setVal(e.target.value.split(','));
  //   }
  // };

  useEffect(() => {
    setColumnGradAbsolute(columnGrad);
  }, []);
  // useEffect(() => {
  //   setDataGradAbsolute([...dataGrad, ...dataArray]);
  // }, [value1, value2, value3, value4, value5, gradeInp, cgpaInp]);

  const handleOnBlur = () => {
    const arrSlider = [...value1, ...value2, ...value3, ...value4, ...value5];
    // for (let i = 0; i < arrSlider.length; i = i + 2) {
    //   if (arrSlider[i] < arrSlider[i + 3]) {
    //     toast.error('Please Enter the Correct Range');
    //   }
    // }
  };
  const columnGrad = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: selectValueCourse === 'Absolute' ? 'Precentile Range' : '',
      accessor: 'precentile_range',
      disableGlobalFilter: true,
    },
    {
      Header: selectValueCourse === 'Absolute' ? 'percentage' : 'percentile',
      accessor: 'percentile',
      disableGlobalFilter: true,
    },
    {
      Header: 'CGPA',
      accessor: 'cgpa',
      disableGlobalFilter: true,
    },
    {
      Header: 'Grade name',
      accessor: 'grade_name',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
  ];

  return (
    <Box>
      <Box>
        <Box pb={3}>
          <Grid item xs={12} sm={4}>
            <KenSelectWrap
              label="Grading Methods"
              options={selectOptionsCourse}
              value={selectValueCourse}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCourse}
              required
            />
          </Grid>
        </Box>
        <ToastContainer />
        {selectValueCourse === 'Absolute' ? (
          <>
            <KenGrid
              columns={columnGridAbsolute}
              data={dataGridAbsolute}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
              initialState={{
                hiddenColumns: ['id'],
              }}
            />
            <div
              style={{ float: 'right', marginTop: '9px', marginBottom: '16px' }}
            >
              <Button
                variant="contained"
                color="primary"
                style={{ padding: '10px', marginRight: '10px' }}
                onClick={() => {
                  handleAddRow();
                }}
              >
                <AiOutlinePlus />
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ padding: '10px' }}
                onClick={() => {
                  handleDiscard();
                }}
                // onClick={manageLayout}
              >
                <BsFillTrashFill />
              </Button>
            </div>
          </>
        ) : (
          <>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={5}>
                <div className="chart-part" style={{ width: '4  0%' }}>
                  <Line data={dataChart} legend={legend} options={options} />
                </div>
              </Grid>
              <Grid item xs={7} style={{ alignSelf: ' baseline' }}>
                <KenGrid
                  // style={{ width: '60%', padding: '0 15px' }}
                  columns={columnGridRelative}
                  data={dataGridRelated}
                  pagination={{ disabled: true }}
                  toolbarDisabled={true}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                />
              </Grid>
            </Grid>

            <div
              style={{ float: 'right', marginTop: '9px', marginBottom: '16px' }}
            >
              <Button
                variant="contained"
                color="primary"
                style={{ padding: '10px', marginRight: '10px' }}
                onClick={() => {
                  handleNewRowRelative();
                }}
              >
                <AiOutlinePlus />
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ padding: '10px' }}
                onClick={() => {
                  handleRelatedDiscard();
                }}
                // onClick={manageLayout}
              >
                <BsFillTrashFill />
              </Button>
            </div>
          </>
        )}
      </Box>
    </Box>
  );
};